export const SALONLIST = "SALONLIST"
export const SALONSTATUS = "SALONSTATUS"
export const SALONDETAILS = "SALONDETAILS"
export const SALONAPPROVEDSTATUS = "SALONAPPROVEDSTATUS"
export const DELETEBUSINESS = "DELETEBUSINESS"
export const SALONUPFDATE = "SALONUPFDATE"
export const SALONDELETE = "SALONDELETE"
export const SALONSUBSCRIPTIONMANAGE = "SALONSUBSCRIPTIONMANAGE"

